import Icon from '../components/Icon.vue'

Icon.register({
  'vr-cardboard': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-160.2c-25.2 0-48-14.8-58.4-37.7l-27.7-61.6c-7.9-17.5-24-28.6-41.7-28.6s-33.8 11.1-41.7 28.6l-27.7 61.6c-10.3 23-33.2 37.7-58.4 37.7h-160.2c-17.7 0-32-14.3-32-32v-320c0-17.7 14.3-32 32-32h576zM160 304c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM480 304c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z'
      }
    ]
  }
})
